class FilterManager {
    namedFilter = [];
    filters = [];

    constructor() {
    }

    addNamedFilter(name) {
        this.namedFilter.push(name);
    }

    addFilter(field, value, operator) {
        this.filters.push({
            field,
            value,
            operator
        });
    }

    removeNamedFilter(name) {
        let index = this.namedFilter.indexOf(name);
        if (index > -1) {
            this.namedFilter.splice(index, 1);
        }
    }

    removeFilter(field, value, operator) {
        let index = this.filters.findIndex((item) => item.field === field && item.value === value && item.operator === operator);
        if (index > -1) {
            this.filters.splice(index, 1);
        }
    }

    hasNamedFilter(name) {
        return this.namedFilter.indexOf(name) > -1;
    }

    hasFilter(field, value, operator) {
        let index = this.filters.findIndex((item) => item.field === field && item.value === value && item.operator === operator);
        return index > -1;
    }

    getNamedFilterArray() {
        return this.namedFilter;
    }

    getFilterArray() {
        return this.filters;
    }
}

export default FilterManager;


// WEBPACK FOOTER //
// ./public/classes/FilterManager.js